import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// import actions
import { setLocale } from 'js/store/app/App.actions';

// import selectors
import { getLocale } from 'js/store/app/App.selectors';

// import components
import ButtonBasic from 'js/components/button/Button.basic';
import { trackEvent } from '../../utils/tracking';

const LocalisationButton = () => {
  const dispatch = useDispatch();

  const data = useSelector((state) => {
    const locale = getLocale(state);
    return {
      locale,
    };
  });

  const changeLocale = () => {
    trackEvent('game_language_select', { language: data.locale === 'en' ? 'Spanish' : 'English' });
    dispatch(setLocale(data.locale === 'en' ? 'es' : 'en'));
  };

  return (
    <ButtonBasic
      style={{ fontSize: 14, padding: '10px 20px', backgroundColor: '#003764', color: 'white', minWidth: 'auto' }}
      title={data.locale === 'en' ? 'ES' : 'EN'}
      action={() => changeLocale()}
    />
  );
};

export default LocalisationButton;
